import { ComponentsOverrides, Theme } from "@mui/material";
import { ciCustomColors } from "@/theme/colors";

type MuiTableHeadType = {
  styleOverrides: ComponentsOverrides<Theme>["MuiTableHead"];
};

const MuiTableHead: MuiTableHeadType = {
  styleOverrides: {
    root: {
      borderBottom: `2px solid ${ciCustomColors.blue[50]}`,
    },
  },
};

export { MuiTableHead };
